const eventNames = {
  adClickThrough: "AdClickThrough",
  adImpression: "AdImpression",
  addPlanItem: "AddPlanItem",
  mediaStarted: "AudioPlayStarted",
  mediaEnded: "AudioPlayEnded",
  categoriesModified: "CategoriesModified",
  challengeViewed: "ChallengeViewed",
  checkedIn: "CheckedIn",
  datePickerOpened: "DatePickerOpened",
  dateRangeAdjusted: "DateRangeAdjusted",
  eventViewed: "EventViewed",
  feedPostViewed: "FeedPostViewed",
  goalViewed: "GoalViewed",
  phoneCallPressed: "PhoneCallPressed",
  websitePressed: "WebsitePressed",
  mapItPressed: "MapItPressed",
  placeViewed: "PlaceViewed",
  shareItem: "ShareItem",
  sharePlan: "SharePlan",
  tourViewed: "TourViewed",
  clientLinkPressed: "ClientLinkPressed",
  getDirectionPressed: "GetDirectionsPressed",
  signIn: "SignIn",
  screenScroll: "ScreenScroll",
};

export { eventNames };
